import React from 'react';

const NotFound = () => (
    <div className="not-found-page">
        404 页面
    </div>
);

export default NotFound;
